import Queries from 'src/services/graphql/queries/index';
import { SensorTypeInput } from 'src/services/graphql/Models';
import SensorType from './classes/SensorType';
import DataStoreExtension from './generic/datastore';
import { DocumentNode } from 'graphql';
import authStore from '../authStore';

export class SensorTypeStore extends DataStoreExtension<SensorTypeInput, SensorType> {
    listQueries: DocumentNode =  Queries.ListSensorTypes;
    
    listVariables: any = {
        input:  {
            clientId: 'global',
            typedId: 'st'
        }
    };

    _createQueries = () => authStore.isSuperUser ? Queries.CreateSensorType : undefined;
    _updateQueries = () => authStore.isSuperUser ? Queries.UpdateSensorType : undefined;
    _deleteQueries = () => authStore.isSuperUser ? Queries.DeleteSensorType : undefined;
    
    constructor() {
        super(false);
    }

    toObject(from: SensorTypeInput): SensorType {
        return new SensorType(from);
    }

    countError(obj: SensorTypeInput) {
        let errors = [];
        const {
            name, 
            isStateBased,
            possibleStates,
            measurement,
            commUnit,
            maxValue,
            minValue
        } = obj;

        if (!name || name.length < 2) {
            errors.push(new Error('SensorName is required'));
        }

        if (isStateBased) {
            if (!Array.isArray(possibleStates) || possibleStates.length <= 2) {
                errors.push(new Error('There must be atleast two state for possible states.'));
            }
        } else {
            if (!measurement || measurement.length <= 2) {
                errors.push(new Error('Measurement type is required'));
            }

            if (!commUnit || commUnit.length <= 2) {
                errors.push(new Error('Unit for communication is required'));
            }

            if (isNaN(Number(maxValue))) {
                errors.push(new Error('Invalid max threshold'));
            }

            if (isNaN(Number(minValue))) {
                errors.push(new Error('Invalid min threshold'));
            }

            if (maxValue < minValue) {
                errors.push(new Error('Maxvalue must be greater then min value'));
            }
        }

        return errors;
    }

    parseDelete(obj: SensorType) {
        return this.parseClientDelete(obj);
    }

}

export default new SensorTypeStore();


// WEBPACK FOOTER //
// ./src/stores/application/sensortype.ts